<div class="buttons-group">
    <!-- Si el conductor està parat, en lloc d'informar d'un problema es resol el parat -->
    <div class="action-card card-problem" *ngIf="canReport() && !isStandStill()" (click)="onReportProblem()">
        <div class="icon-wrapper">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
        <div class="card-body">
            <div class="card-title">{{ 'SHARED.EXTERNAL.CMR.PHASE.REPORTPROBLEM.CAPTION' | translate }}</div>
            <div class="card-desc">{{ 'SHARED.EXTERNAL.CMR.PHASE.REPORTPROBLEM.HELP' | translate }}</div>
        </div>
        <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
    </div>
    <div class="action-card card-problem" *ngIf="isStandStill()" (click)="onResolveStandStill()">
        <div class="icon-wrapper">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
        <div class="card-body">
            <div class="card-title">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.RESOLVE.CAPTION' | translate }}</div>
            <div class="card-desc">{{ 'SHARED.ROUTE.ACTIVE.INCIDENT.STANDSTILL.RESOLVE.HELP' | translate }}</div>
        </div>
        <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
    </div>
    <div class="action-card card-comment" (click)="onAddComment()">
        <div class="icon-wrapper">
            <i class="fa fa-comment" aria-hidden="true"></i>
        </div>
        <div class="card-body">
            <div class="card-title">{{ 'SHARED.EXTERNAL.CMR.ACTIONS.CREATEEVENT.CAPTION' | translate }}</div>
            <div class="card-desc">{{ 'SHARED.EXTERNAL.CMR.ACTIONS.CREATEEVENT.PHASE.HELP' | translate }}</div>
        </div>
        <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
    </div>
</div>
